import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { getInclusionIcon } from 'lib/getInclusionIcon'

const StyledInclusionItemDiv = styled.div`
  display: flex;
  align-items: center;
`

const InclusionItemText = styled(BodyText)`
  margin-top: 0;
  padding-left: ${rem(8)};
  text-indent: ${rem(-2)};
`

const StyledIconDiv = styled.div`
  position: relative;
  top: 2px;
`

interface Props {
  inclusion: App.InclusionV2;
  isHighlighted?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const InclusionItem = ({ inclusion, isHighlighted, size = 'medium' }: Props) => {
  const InclusionIcon = useMemo(() => getInclusionIcon(inclusion.category?.icon || ''), [inclusion])

  return <StyledInclusionItemDiv key={inclusion.id}>
    <StyledIconDiv>
      <InclusionIcon
        data-testid={inclusion?.category?.icon || 'default_icon'}
        size="XS"
        colour={isHighlighted ? 'secondary-normal' : undefined}
      />
    </StyledIconDiv>
    <InclusionItemText
      variant={size}
      weight={isHighlighted ? 'bold' : 'normal'}
    >
      {inclusion.name}
    </InclusionItemText>
  </StyledInclusionItemDiv>
}

export default InclusionItem
